import React, { memo } from "react";
import ServicesMenu from "./nav/ServicesMenu";
import AboutUsMenu from "./nav/AboutUsMenu";

const MainNav = memo(({ onNavigate, mobileDrawerOpen }) => (
  <nav
    id="header-main-nav"
    className="header__menu--newWrap vh-main-nav"
    aria-label="Primary"
  >
    <ul id="menu-header-menu-redesigned" className="header__menu--new vh-topnav">
      <ServicesMenu
        onNavigate={onNavigate}
        mobileDrawerOpen={mobileDrawerOpen}
      />
      <AboutUsMenu
        onNavigate={onNavigate}
        mobileDrawerOpen={mobileDrawerOpen}
      />
    </ul>
  </nav>
));

export default MainNav;
